import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import reportWebVitals from './reportWebVitals';
import { store } from './store/store';
import { history } from './store/rootReducer';
import { App } from './app/App';
import { pdfjs } from 'react-pdf';

import './services/firebase/firebaseConfig';
import 'bootstrap/dist/css/bootstrap.css';
import './i18n';
import './index.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// Measuring performance in your app
// Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
